export default "__VITE_ASSET__BpHJDQPe__"